import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import Swal from 'sweetalert2'
import { ApiService } from '../api.service'

@Component({
	selector: 'export-course',
	templateUrl: './export-course.component.html',
	styleUrls: ['./export-course.component.scss']
})

export class ExportCourseComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	baseUrl = ''

	@Input() course = 0
	@Input() name: any = ''
	@Input() type: 'desktop' | 'mobile' | 'pdf' = 'desktop'
	@Input() language: 'es' | 'en' | 'cn' = 'es'
	@Input() previewOnly = false
	@Input() translations: any = []
	multiTransl = false
	transl = 'all'

	status = ''
	statusMsg = ''
	exportedLink = ''
	logLink = ''
	unitPreviews: any[] = []

	activitiesTestsErrors: any[] = []
	multimediaErrors: any[] = []
	htmlErrors: any[] = []

	exporting = false
	exportSuccess = false
	exportError = false

	moodleCourses: any[] = []
	selectedMoodleCourse = ''

	sendingToMoodle = false
	sendToMoodleSuccess = false
	sendToMoodleError = false

	exportCourseSub = new Subscription
	exportStatusSub = new Subscription
	getMoodleCoursesSub = new Subscription
	checkCourseErrorsActivitiesTestsSub = new Subscription
	checkCourseErrorsMultimediaSub = new Subscription
	checkCourseErrorsHtmlSub = new Subscription
	exportMoodleSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService) { }

	ngOnInit() {
		this.baseUrl = this.dataService.remoteBaseUrl
		this.multiTransl = this.translations.length > 1
	}

	ngAfterViewInit() {}

	ngOnChanges() {
		this.exporting = false
		this.exportSuccess = false
		this.exportError = false
		this.status = ''
		this.statusMsg = ''
		this.exportedLink = ''
		this.logLink = ''
		this.unitPreviews = []
		this.activitiesTestsErrors = []
		this.multimediaErrors = []
		this.htmlErrors = []
	}

	ngOnDestroy() {
		this.exportCourseSub?.unsubscribe()
		this.exportStatusSub?.unsubscribe()
		this.getMoodleCoursesSub?.unsubscribe()
		this.checkCourseErrorsActivitiesTestsSub?.unsubscribe()
		this.checkCourseErrorsMultimediaSub?.unsubscribe()
		this.checkCourseErrorsHtmlSub?.unsubscribe()
		this.exportMoodleSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	courseAutocompleteOnSelect(item: any) {
		// console.log(item)
		this.selectedMoodleCourse = item.idnumber.toLowerCase()
	}
	
	courseAutocompleteOnChangeSearch(search: string) {
		// console.log(search)
		if (search == null || search == '') this.selectedMoodleCourse = ''
	}

    courseAutocompleteOnFocused(e: void) {
		// console.log(e)
	}

	export() {
		let exportName = this.name
		if (this.transl != 'all') {
			exportName = this.name[this.transl]
		}

		this.exporting = true
		this.exportSuccess = false
		this.exportError = false

		this.exportCourseSub = this.dataService.exportCourse(this.course, exportName, this.type, this.language, this.transl)
		.subscribe({
			next: (data) => {
				console.log(data)
			},
			error: (e) => {
				console.log(e)
			},
		})

		let interval = setInterval(() => {
			this.exportStatusSub = this.dataService.exportStatus(this.course)
			.subscribe({
				next: async (data) => {
					console.log(data)
					let status = data.status

					this.status = status
					this.statusMsg = data.message
					
					if (status == 'FINISHED') {
						this.status = 'CHECKING'
						clearInterval(interval)
						// this.exportSuccess = true
						// this.exportError = false

						if (!this.previewOnly) {
							this.exportedLink = `${this.baseUrl}/php/brainscorm/${data.exportedfile}`
							this.logLink = `${this.baseUrl}/php/brainscorm/${data.log}`
						}
						
						let previews = data.previews
						previews.forEach((element: string) => {
							element = `${this.baseUrl}/php/brainscorm/${element}`
						})
						this.unitPreviews = previews

						if (!this.exportError) {
							this.statusMsg = '(Revisando actividades y evaluaciones)'
							// this.activitiesTestsErrors = await this.checkCourseErrorsActivitiesTests()

							this.statusMsg = '(Revisando referencias multimedia)'
							this.multimediaErrors = await this.checkCourseErrorsMultimedia()
	
							this.statusMsg = '(Revisando errores HTML)'
							this.htmlErrors = await this.checkCourseErrorsHtml()
	
							this.status = 'FINISHED'
							this.statusMsg = ''
							if (this.activitiesTestsErrors.length == 0 && this.multimediaErrors.length == 0 && this.htmlErrors.length == 0) {
								this.exportSuccess = true
								this.exportError = false
							} else  {
								this.exportSuccess = false
								this.exportError = true
							}
						}

						/*
						this.getMoodleCoursesSub = this.dataService.getMoodleCourses()
						.subscribe(
							courses => {
								// console.log(courses)
								this.moodleCourses = courses
							},
							error => {
								console.log(error)
							},
						)
						*/
					}
				},
				error: (e) => {
					console.log(e)
					this.exportSuccess = false
					this.exportError = true
					clearInterval(interval)
				},
			})
		}, 1000)
	}

	async checkCourseErrorsActivitiesTests() {
		let errors: any[] = []
		
		this.checkCourseErrorsActivitiesTestsSub = this.dataService.checkCourseErrorsActivitiesTests(this.course, this.multiTransl, this.language)
		.subscribe({
			next: (data) => {
				console.log(data)
				errors = data
			},
			error: (e) => {
				console.log(e)
				this.exportSuccess = false
				this.exportError = true
			}
		})

		return errors
	}

	async checkCourseErrorsMultimedia() {
		let errors: any[] = []

		this.checkCourseErrorsMultimediaSub = this.dataService.checkCourseErrorsMultimedia(this.course)
		.subscribe({
			next: (data) => {
				console.log(data)
				errors = data
			},
			error: (e) => {
				console.log(e)
				this.exportSuccess = false
				this.exportError = true
			},
		})

		return errors
	}

	async checkCourseErrorsHtml() {
		let errors: any[] = []

		this.checkCourseErrorsHtmlSub = this.dataService.checkCourseErrorsHtml(this.course)
		.subscribe({
			next: (data) => {
				console.log(data)
				errors = data
			},
			error: (e) => {
				console.log(e)
				this.exportSuccess = false
				this.exportError = true
			},
		})

		return errors
	}

	exportMoodle() {
		if (this.selectedMoodleCourse == '') {
			Swal.fire('Error', 'No ha seleccionado un curso.', 'error')
			return
		}

		this.sendingToMoodle = true
		this.sendToMoodleSuccess = false
		this.sendToMoodleError = false

		this.exportMoodleSub = this.dataService.exportMoodle(this.course, this.selectedMoodleCourse, this.type)
		.subscribe({
			next: (_data) => {
				// console.log(data)

				this.sendingToMoodle = false
				this.sendToMoodleSuccess = true
				this.sendToMoodleError = false
			},
			error: (_e) => {
				// console.log(e)

				this.sendingToMoodle = false
				this.sendToMoodleSuccess = false
				this.sendToMoodleError = true
			},
		})
	}

}
